// These should match the contents of the `notification_types` table
export const NOTIFICATION_TYPES = Object.freeze({
  DAILY_DIGEST: 'DAILY_DIGEST',
  EXECUTIVE_SUMMARY: 'EXECUTIVE_SUMMARY',
  INCOMING_TEXT_NOTIFICATION: 'INCOMING_TEXT_NOTIFICATION',
  WEEK_IN_REVIEW: 'WEEK_IN_REVIEW',
  APPLICANT_REACH_OUT: 'APPLICANT_REACH_OUT',
});

export type NotificationTypeName = keyof typeof NOTIFICATION_TYPES;

export type NotificationType = {
  type: NotificationTypeName;
  description: string;
  isScheduled: boolean;
  isWeekly: boolean;
};
